import * as request from '@/utils/request'

export default {
   /**
   * @description 获取协议双方
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getSignHomeInfo(parmas) {
    return request.get('/sign/home', parmas, {
      baseURL: ''
    })
  },
  //导出电子回单(新)
  postExportReceipt(parmas) {
    return request.post('/mixin/exportReceipt', parmas)
  },
}